var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-editions",class:{
    'tw-py-6': true,
    'md:tw-flex md:tw--mx-4 md:tw-justify-center': true,
  }},_vm._l((_vm.plugin.editions),function(edition,key){return _c('plugin-edition',{key:key,staticClass:"md:tw-flex-1 md:tw-mx-4 md:tw-max-w-xs",attrs:{"plugin":_vm.plugin,"edition":edition}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }